import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

export interface RealtimeOrder {
  orderId: string;
  price: string;
  amount: string;
  side: 'buy' | 'sell';
  market: string;
  blockHeight: string;
  txHash: string;
  timestamp: number;
  isNew?: boolean;
}

interface OrderState {
  // Real-time orders from WebSocket
  realtimeOrders: RealtimeOrder[];
  maxOrders: number;

  // UI state
  isScrolling: boolean;
  autoScroll: boolean;

  // Actions
  addRealtimeOrder: (order: RealtimeOrder) => void;
  addRealTimeOrders: (orders: RealtimeOrder[]) => void;
  clearRealtimeOrders: () => void;
  setAutoScroll: (enabled: boolean) => void;
  setIsScrolling: (scrolling: boolean) => void;
}

export const useOrderStore = create<OrderState>()(
  subscribeWithSelector(set => ({
    // Initial state
    realtimeOrders: [],
    maxOrders: 10000, // Keep last 100 orders for performance
    isScrolling: false,
    autoScroll: true,

    // Actions
    addRealtimeOrder: (order: RealtimeOrder) => {
      set(state => {
        const newOrders = [order, ...state.realtimeOrders].slice(0, state.maxOrders);
        return {
          realtimeOrders: newOrders,
        };
      });
    },

    addRealTimeOrders: (orders: RealtimeOrder[]) => {
      set(state => {
        const newOrders = [...orders, ...state.realtimeOrders].slice(0, state.maxOrders);
        return {
          realtimeOrders: newOrders,
        };
      });
    },

    clearRealtimeOrders: () => {
      set({ realtimeOrders: [] });
    },

    setAutoScroll: (enabled: boolean) => {
      set({ autoScroll: enabled });
    },

    setIsScrolling: (scrolling: boolean) => {
      set({ isScrolling: scrolling });
    },
  })),
);
